import { ShopListEffects } from './shop-list.effect';

export const effects: any[] = [ShopListEffects];
